import React from 'react';
import { Settings, GraduationCap } from 'lucide-react';

export default function Header() {
  return (
    <>
      <div className="absolute top-6 left-1/2 -translate-x-1/2 md:left-auto md:right-24 md:translate-x-0 md:top-8 flex items-center gap-3 z-20">
        <div className="flex items-center gap-2 bg-white/80 backdrop-blur rounded-full px-4 py-2 shadow-sm">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#a020c9] to-[#ec2fd2] flex items-center justify-center text-white">
            <GraduationCap size={20} />
          </div>
          <div className="leading-tight">
            <div className="text-[10px] uppercase tracking-widest text-[#7a1fb0] font-bold">Academia</div>
            <div className="text-sm font-heading font-extrabold text-[#2b1039]">de Pitágoras</div>
          </div>
        </div>
      </div>
      <button className="settings-float" aria-label="Configurações">
        <Settings size={20} />
      </button>
    </>
  );
}
